
import authImg from "assets/img/auth/auth.jpg";
import { Link, Routes, Route, Navigate } from "react-router-dom";
import SignIn from "../../views/auth/SignIn";
import Forbidden from "views/auth/forbidden";
import routes from "routes.js";

export default function Auth() {
  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.layout === "/auth") {
        return (
          <Route path={`/${prop.path}`} element={prop.component} key={key} />
        );
      } else {
        return null;
      }
    });
  };
  document.documentElement.dir = "rtl";
  return (
    <div>
      <div className=" h-full min-h-screen w-full">
        <main className={`mx-auto min-h-screen`}
          style={{
            backgroundImage: `url(${authImg})`,
            backgroundPosition: "center",
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
          }}>
          <div className="relative flex ">
            <div className="mx-auto flex min-h-full w-full flex-col items-center justify-center pt-12 md:max-w-[75%] lg:h-screen lg:max-w-[1013px] lg:px-8 lg:pt-0 xl:h-[100vh] xl:max-w-[1383px] xl:px-0 ">
              <div className="mb-auto flex flex-col pl-5 pr-5 w-full lg:w-[60%]">
                <Routes>
                  {getRoutes(routes)}
                  <Route
                    path="/"
                    // element={<Navigate to="/auth/sign-in" replace />}
                    element={<SignIn />}
                  />
                  <Route
                    path="/forbidden"
                    element={<Forbidden />}
                  />
                </Routes>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
